<template>
  <div class="link-shortener" :class="$store.state.theme">
    <MainBackButton />

    <p class="header has-text-left" @click="getShortLinks">
      <span class="title is-5 has-text-primary" style="padding-left:55px">Link Shortener</span>
      <span class="is-pulled-right tag is-primary">{{ hostURL() }}</span>
    </p>

    <i v-show="loading" class="fa fa-cog fa-10x fa-spin" />

    <div class="new has-text-left">
      <p>
        <span style="opacity:0.7; font-weight:600" @click="info">
          New Short Link
          <i class="fa fa-info-circle" />
        </span>
        <a class="tag is-link is-rounded is-pulled-right save" @click="createNewShortLink">Save</a>
      </p>
      <div class="field">
        <div class="control">
          <textarea
            v-model="newPath"
            class="textarea is-primary"
            placeholder="eat?r=cm&s=payday"
            rows="2"
          ></textarea>
          <i class="fa fa-external-link-alt" @click="gotoNewPath" />
        </div>
      </div>
      <div class="buttons">
        <a class="button is-small">Region</a>
        <a class="button is-small">Distance</a>
        <a class="button is-small">Search</a>
        <a class="button is-small">Advertising</a>
        <a class="button is-small">Language</a>
      </div>
    </div>
    <section class="notification no-scrollbar" :key="z">
      <div v-for="(o,i) in shortLinks" :key="i">
        <div class="columns is-mobile is-vcentered">
          <div class="column is-narrow" style="width:100px">
            <i
              class="fa fa-link fa-lg has-text-link"
              style="margin-right:16px"
              @click="gotoShortLink(o)"
            />
            <i class="fa fa-qrcode fa-lg has-text-success" @click="showQRCode(o)" />
            <p class="has-text-link has-text-weight-medium">{{ o.short_id }}</p>
            <p class="tag" :class="{'has-text-danger': isValid(o)}">{{ o.state }}</p>
          </div>
          <div class="column has-text-left" style="width:calc(100vw - 200px)">
            <p class="clamp" @click="viewURL(o)">{{ o.url }}</p>
            <p>
              <span class="tag is-info">{{ timeAgo(o.created_at) }}</span>
              <span
                class="tag is-pulled-right"
                @click="infoToast('Validity: '+o.validity)"
              >{{ expiryDate(o) }}</span>
            </p>
          </div>
          <!-- <div class="column is-narrow has-text-left">
            <p class="tag is-rounded is-medium handle" style="padding:10px; margin:4px">
              <span class="has-text-black is-grey">{{ o.rank }}</span>&nbsp;
              <i class="fa fa-grip-lines has-text-success fa-lg" />
            </p>
          </div>-->
        </div>
      </div>
      <div class="has-text-centered" style="margin: -5px 0;">
        <img src="/img/home2/minus.svg" style="width:30px; margin-bottom:-15px; padding:0 0" />
      </div>
    </section>
  </div>
</template>


<script>
import MainBackButton from "@/components/MainBackButton";

export default {
  name: "LinkShortener",
  components: { MainBackButton },
  data() {
    return {
      newPath: null,
      loading: true,
      shortLinks: [],
      lists: [],
      edited: false,
      z: 0,
    };
  },
  computed: {},
  mounted() {
    this.getShortLinks();
  },
  methods: {
    // createShortLink() {
    //   var longShopURL = `/shop/${this.business.id}`;
    //   var shortLinkID = "~" + this.randomSixChars();
    //   var validity = 60 * 24 * 365 * 100; // valid for 100 years
    //   this.shortenLink(longShopURL, shortLinkID, validity); // should check for clash
    // },
    randomSixChars() {
      return (
        Math.random().toString(36).substring(2, 5) +
        Math.random().toString(36).substring(2, 5)
      );
    },
    getShortLinks() {
      this.loading = true;
      this.shortLinks = []; // reset lists before getting new blobs
      this.$store
        .dispatch("getRecentShortLinks")
        .then((res) => {
          if (res.data) this.shortLinks = res.data;
          else this.errorToast(`No short links exist`);
        })
        .catch((err) => this.apiError(err))
        .finally(() => (this.loading = false));
    },
    saveBlob(o) {
      //   var loader = this.loadingDots("purple");
      this.$store
        .dispatch("saveBlob", o)
        .then(() => {
          this.edited = false;
          //   this.success();
          //   this.successToast("Saved list " + o.data.rank);
        })
        .catch((err) => this.apiError(err));
      // .finally(() => loader.hide());
    },
    checkPath(path) {
      this.$router.push(path).catch((err) => this.errorToast(err));
    },
    shareLink(o) {
      this.infoToast("Share list link coming soon!", "top");
    },
    isValid(o) {
      var endTime = new Date(o.created_at).getTime() + o.validity * 1000;
      return new Date().getTime() > endTime;
    },
    expiryDate(o) {
      var endTime = new Date(o.created_at).getTime() + o.validity * 1000;
      return new Date(endTime).toLocaleDateString();
    },
    showQRCode(o) {
      this.infoToast("QR code coming soon!");
    },
    gotoShortLink(o) {
      var id = o.short_id;
      var url = this.hostURL() + "q/" + id;
      if (id.startsWith("~") || id.startsWith("@")) {
        url = this.hostURL() + id;
      }
      this.$swal({
        title: `Short Link`,
        html: `<div style='font-size:1.1em'>${url}</div>`,
        confirmButtonText: `Open&nbsp;<i class='fa fa-external-link-alt'></i>`,
        confirmButtonColor: this.bulmaColor("link"),
        showCloseButton: true,
        showCancelButton: true,
        cancelButtonText: `Copy&nbsp;<i class='fa fa-copy'></i>`,
        cancelButtonColor: this.bulmaColor("primary"),
      }).then((val) => {
        if (val.value) window.location = url;
        else {
          this.$copyText(url);
          this.infoToast("Copied link 🔗", "top");
        }
      });
    },
    gotoNewPath() {
      if (!this.newPath) return this.warningToast("Enter a path");
      this.$router.push(this.newPath).catch((err) => console.error(err));
    },
    createNewShortLink() {
      if (!this.newPath) return this.warningToast("Enter a path");
      this.loading = true;
      this.$store
        .dispatch("createShortLink", {
          url: this.newPath,
          short_id: "~" + this.randomSixChars(),
          validity: 60 * 24 * 365 * 100, // valid for 100 years
        })
        .then(() => {
          this.successToast("Success");
          this.getShortLinks();
          this.newPath = null; // clear for new
        })
        .catch((err) => this.apiError(err));
    },
    viewURL(o) {
      this.$swal({
        // title: o.url,
        html: `<div style='font-size:1.2em'>${o.url}</div>`,
        confirmButtonText: `Go to path&nbsp;<i class='fa fa-chevron-right'></i>`,
        confirmButtonColor: this.bulmaColor("success"),
      }).then((val) => {
        if (val.value)
          this.$router.push(o.url).catch((err) => console.error(err));
      });
    },
    info() {
      this.$swal({
        title: `<i class='fa fa-info-circle' style='color:lightgreen'></i>`,
        html: `Info on short links and defaults`,
        showCloseButton: true,
        showConfirmButton: false,
      });
    },
  },
};
</script>

<style scoped>
.link-shortener {
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}
.dark.link-shortener,
.dark section {
  background-color: #123;
}
.header {
  padding-top: 18px;
  margin-right: 10px;
}
.column {
  padding: 6px;
}
.columns {
  position: relative;
  margin: 5px 10px;
  border: 1px solid grey;
  border-radius: 10px;
  background-color: white;
}
.notification {
  padding: 0px;
  margin: 8px 0;
  overflow-y: scroll;
  overflow-x: hidden;
  height: calc(100vh - 242px);
}
.reminder {
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 10px;
  color: red;
}
.categories span {
  margin-right: 6px;
}
.button.is-small.is-rounded {
  padding: 0 6px;
  margin-top: 3px;
}
.single-line {
  white-space: nowrap;
  overflow: auto;
  display: inline-block;
}
.tags {
  padding: 0;
  margin: 0;
}
.fa-share-alt {
  margin-top: 8px;
}
.list-btns .button {
  display: block;
  margin-bottom: 10px;
}
.fa-cog {
  position: absolute;
  top: calc(50vh - 80px);
  left: calc(50vw - 80px);
  z-index: 2;
}
/* clamp ellipsis to 2 lines */
.clamp {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  padding-right: 4px;
}
.new {
  border-radius: 8px;
  margin: 10px;
  margin-bottom: -6px;
  padding: 10px;
  background-color: lightgreen;
  box-shadow: 0px 0px 3px grey;
}
.save {
  margin-top: -4px;
}
.fa-external-link-alt {
  position: absolute;
  right: 6px;
  top: 43px;
  background-color: lightseagreen;
  color: white;
  padding: 3px;
  border-radius: 4px;
}
</style>